/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalEvidenceImageSignedUrlRequest
 */
export interface ExternalEvidenceImageSignedUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof ExternalEvidenceImageSignedUrlRequest
     */
    url: string;
}

/**
 * Check if a given object implements the ExternalEvidenceImageSignedUrlRequest interface.
 */
export function instanceOfExternalEvidenceImageSignedUrlRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function ExternalEvidenceImageSignedUrlRequestFromJSON(json: any): ExternalEvidenceImageSignedUrlRequest {
    return ExternalEvidenceImageSignedUrlRequestFromJSONTyped(json, false);
}

export function ExternalEvidenceImageSignedUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEvidenceImageSignedUrlRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function ExternalEvidenceImageSignedUrlRequestToJSON(value?: ExternalEvidenceImageSignedUrlRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

